import React from "react";
import "./CustomPaginate.css";
import Pagination from "react-bootstrap/Pagination";

const CustomPaginate = ({ currentPage, totalPages, handlePageChange }) => {
  const pageRange = 2; // tighter and cleaner UX

  const renderPageItems = () => {
    const items = [];

    // ✅ Prev
    items.push(
      <Pagination.Prev
        key="prev"
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      />
    );

    let start = currentPage - pageRange;
    let end = currentPage + pageRange;

    // ✅ FIX: Adjust when near start
    if (currentPage <= pageRange + 1) {
      start = 1;
      end = Math.min(totalPages, pageRange * 2 + 1);
    }

    // ✅ FIX: Adjust when near end
    if (currentPage >= totalPages - pageRange) {
      end = totalPages;
      start = Math.max(1, totalPages - pageRange * 2);
    }

    // ✅ Start ellipsis
    if (start > 1) {
      items.push(
        <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );

      if (start > 2) {
        items.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }
    }

    // ✅ Page numbers
    for (let page = start; page <= end; page++) {
      items.push(
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </Pagination.Item>
      );
    }

    // ✅ End ellipsis
    if (end < totalPages) {
      if (end < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      items.push(
        <Pagination.Item
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    // ✅ Next
    items.push(
      <Pagination.Next
        key="next"
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
      />
    );

    return items;
  };

  return <Pagination>{renderPageItems()}</Pagination>;
};

export default CustomPaginate;